import { useEffect, useRef } from 'react';
import '@ambulnz/amb-header';

const AmbHeaderWrapper = ({ onPreferredSelected, onAllPreferredUnset, ...rest }) => {
  const elementRef = useRef(null);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    const setPreferredHandler = event => {
      if (typeof onPreferredSelected === 'function') {
        onPreferredSelected(event.detail);
      }
    };

    const unsetAllPreferredHandler = event => {
      if (typeof onAllPreferredUnset === 'function') {
        onAllPreferredUnset(event.detail);
      }
    };

    element.addEventListener('setPreferredUserFacility', setPreferredHandler);
    element.addEventListener('unsetAllPreferredUserFacilities', unsetAllPreferredHandler);

    return () => {
      element.removeEventListener('setPreferredUserFacility', setPreferredHandler);
      element.removeEventListener('unsetAllPreferredUserFacilities', unsetAllPreferredHandler);
    };
  }, [onPreferredSelected, onAllPreferredUnset]);

  return <amb-header ref={elementRef} {...rest}></amb-header>;
};

export default AmbHeaderWrapper;
